import { Box, Chip, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import type {
  ProcessedFormField,
  ResolvedOption,
} from "@/types/api/formSchema";
import { resolveSelectOptions } from "../utils/schemaUtils";

type Props = {
  field: ProcessedFormField & { resolvedOptions?: ResolvedOption[] };
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  name: string;
};

export function RadioField({ field: schemaField, value, onChange }: Props) {
  const options = schemaField.resolvedOptions ?? resolveSelectOptions(schemaField);

  return (
    <Box>
      <Typography
        variant="caption"
        sx={{ display: "block", color: "text.secondary", mb: 1 }}
      >
        Select one
      </Typography>
      <Box
        role="radiogroup"
        aria-label={schemaField.resolvedLabel}
        sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
      >
        {options.map((opt) => {
          const isSelected = value === opt.name;
          const isOptDisabled =
            !!schemaField.disabled ||
            ("disabled" in opt && !!(opt as ResolvedOption).disabled);
          return (
            <Chip
              key={opt.name}
              role="radio"
              aria-checked={isSelected}
              disabled={isOptDisabled}
              icon={isSelected ? <CheckIcon fontSize="small" /> : undefined}
              label={opt.display_name}
              onClick={() => !isOptDisabled && onChange(opt.name)}
              color={isSelected ? "primary" : "default"}
              variant={isSelected ? "filled" : "outlined"}
              sx={{ cursor: isOptDisabled ? "not-allowed" : "pointer" }}
            />
          );
        })}
      </Box>
    </Box>
  );
}
